import React from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import memoWithName from '@/hocs/memoWithName'
import useSvgColors from '@/hooks/useSvgColors'

const GeoZoneIcon = ({ color, onClick }) => {
  const {
    fill,
  } = useSvgColors(color)

  return (
    <svg
      onClick={onClick}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM14.8 9.15C14.8 12.08 11.16 15.85 10 16.9C8.84 15.85 5.2 12.08 5.2 9.15C5.2 6.22 7.35 3.85 10 3.85C12.65 3.85 14.8 6.22 14.8 9.15ZM10 11.07C10.97 11.07 11.77 10.24 11.77 9.22C11.77 8.19 10.97 7.17 10 7.17C9.01 7.17 8.23 8.19 8.23 9.22C8.23 10.24 9.01 11.07 10 11.07Z"
        fill={fill}
        className="svgFill"
      />
    </svg>
  )
}

GeoZoneIcon.propTypes = {
  color: pt.string,
  onClick: pt.func,
}

GeoZoneIcon.defaultProps = {
  color: null,
  onClick: noop,
}

export default memoWithName(GeoZoneIcon)
